import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useFacetOptions } from '../useFacetOptions';
import { ValidatedSingleStringValueInputProps } from '../types';
import { CastType } from '../../../../types';

export const SingleLongInput = ({
  value,
  onChange,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
  castType,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueSingleStringInput, ConditionValueSingleNumberInput } =
    useVisualComponentsContext();
  const { options, didError, isLoading } = useFacetOptions({
    dataType,
    field,
  });

  const isDisabled = isReadOnly || isLoading || didError;
  const hasError = didError || !!isInvalid;
  const VisualComponent =
    castType === CastType.MERGE_PARAM
      ? ConditionValueSingleStringInput
      : ConditionValueSingleNumberInput;

  return (
    <VisualComponent
      onChange={(val) => {
        if (val) onChange(val);
      }}
      value={value}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={isDisabled}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      options={options}
      placeholder={t('v2.conditionBuilder.singleLongPlaceholder')}
    />
  );
};
